// apps/patient/src/App.tsx

import AppRouter from './routes/index';
import { PWAInstallButton } from './components/ui/PWAInstallButton';

export default function App() {
  return (
    <>
      <AppRouter />
      <PWAInstallButton />
    </>
  );
}